// extracted by mini-css-extract-plugin
export var downArrow = "_ie-0";
export var infoTooltipIcon = "_ie-3";
export var label = "_ie-1";
export var optionCard = "_ie-4";
export var upArrow = "_ie-2";